import { randomArray } from '@library/common/functions';
import { MockPath } from '@library/common/http/mock-path.mock';

import { MockUser } from './mock/user.mock';
import { MockAccount } from './mock/account.mock';

export const mockUser = new MockUser({ skipReports: true });

export const UserRoutes: MockPath<any>[] = [
   { path: 'user/login', verb: 'POST', collection: () => [{ token: 'test-token' }] },

   { path: 'user', verb: 'GET', type: 'User', collection: () => [ mockUser ] },

   { path: 'user/account', verb: 'GET', collection: () => {
      const accounts = randomArray( MockAccount, 30 );
      if ( accounts.length ) {
         accounts[0].primary = true;
         accounts[0].active = true;
      }

      return accounts;
   }},

   { path: 'user/preferences', verb: 'POST', collection: opts => {
      console.log( `* mock - ${opts.verb} ${opts.url}`, opts.body );

      return [];
   }},
];
